import React ,{useState}from 'react'
import {Container,Table,Form,Col, FormControl, FormGroup} from "react-bootstrap"
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import questions from './data.json'
import Title from "../../utilities/other/title"
class RBDQS extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            score:0,
            "10":"", // CHECK LAST ANSWER FOR RDBQS 
           
        }
    }
    onChange = async (event) =>{
        const {name,value} = event.target
       await this.setState((prevState)=>({
            ...prevState,
            [name]:`${value}`
        }))
        this.props.handler('rbdsq',this.state )
       
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
    }
    Answer_10_Yes(){
        const handleAnswer = async  (event)=>{
           await this.setState({"10_yes":event.target.value})
            this.props.handler('rbdsq',this.state )
            if(this.state['10']=="No"){
                this.setState({"10_yes":undefined})
            }
        }
        return(
            <Table>
                <tbody>
                    <tr>
                        <td>Disease:</td>
                        <td width={380}>
                            <Form.Group>
                                <Form.Label></Form.Label>
                                <Form.Control type={'text'} onChange={handleAnswer}  name={"10_yes"} value={this.state['10_yes']} disabled={this.props.disabled}/>
                            </Form.Group>
                        </td>
                    </tr>
                </tbody>
            </Table>
        )
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state){
    //         this.props.handler('rbdqs',this.state )
    //     }
    // }
    render(){
        return(
            <Container>
                <Title> RBD Screening Questionnaire</Title><br/>
                <Questions_Table title= 'fab' score={true} scoreFunc={this.Scoring} questions={questions} data={this.props.data} disabled={this.props.disabled} answers={questions} handler={this.onChange} fieldName={'fab'}/>
                {this.state["10"] == "Yes" && this.Answer_10_Yes()}
                <Table>
                    <thead>
                        <tr>
                            <th>Score:</th>
                            <th><p className={'score'}>{this.state.score}</p></th>
                        </tr>
                    </thead>
                </Table>
            </Container>
        )
    }
}

export default RBDQS

